import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as Styled from './BranchingInputArea.styled';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectChatState,
  ChatStates,
  prevNodeSelector,
  setScrollToEndChatLog,
  chatErrorSelector,
  resendGreetingSelector,
  resendFormDataSelector,
  resendFreeTextInputDataSelector,
  resendBranchingAITextDataSelector,
  virtualHumanTalkingSelector,
} from '../../../../slices/chat/ChatSlice';
import {
  sendBranchingAIText,
  sendBranchingFreeText,
  sendBranchingOption,
} from '../../../../slices/chat/ChatThunks';
import { usePrevious } from '../../../../utility/StateHooks';
import { virtualHumanDataSelector } from '../../../../slices/VirtualHumanSlice';
import ChatRequestError from '../../../ChatRequestError/ChatRequestError';
import { useVHTypeConfig } from '../../vhTypeHooks';
import FreeTextInputEditor from './FreeTextInputEditor/FreeTextInputEditor';
import BranchingOptions from './BranchingOptions/BranchingOptions';

const BranchingInputArea = (props) => {
  const dispatch = useDispatch();
  const chatState = useSelector(selectChatState);
  const vh = useSelector(virtualHumanDataSelector);
  const resendGreeting = useSelector(resendGreetingSelector);
  const { getGreetingThunk } = useVHTypeConfig();
  const resendFormData = useSelector(resendFormDataSelector);

  const isSendingChat = useSelector((state) => state.chat.status === 'pending');
  const chatLoadingStatus = useSelector((state) => state.chat.status);

  const prevRenderedNode = useSelector(prevNodeSelector);
  const showFreeTextEditor =
    prevRenderedNode?.action === 'freeText' ||
    prevRenderedNode?.action === 'ai';
  const prevShowFreeTextEditor = usePrevious(showFreeTextEditor);
  useEffect(() => {
    if (showFreeTextEditor && !prevShowFreeTextEditor) {
      dispatch(setScrollToEndChatLog(true));
    }
  }, [showFreeTextEditor, prevShowFreeTextEditor, dispatch]);

  const resendFreeTextInputData = useSelector(resendFreeTextInputDataSelector);
  const resendAITextInputData = useSelector(resendBranchingAITextDataSelector);
  const virtualHumanTalking = useSelector(virtualHumanTalkingSelector);

  const chatError = useSelector(chatErrorSelector);
  const resend = useCallback(() => {
    if (resendGreeting) {
      dispatch(getGreetingThunk()(vh.ExternalID));
    } else if (resendFreeTextInputData) {
      dispatch(sendBranchingFreeText(resendFreeTextInputData));
    } else if (resendAITextInputData) {
      dispatch(sendBranchingAIText(resendAITextInputData));
    } else {
      dispatch(sendBranchingOption(resendFormData));
    }
  }, [
    dispatch,
    getGreetingThunk,
    resendFormData,
    resendFreeTextInputData,
    resendGreeting,
    vh.ExternalID,
    resendAITextInputData,
  ]);

  if (!virtualHumanTalking && chatState === ChatStates.COMPLETE) {
    return null;
  }

  return (
    <Styled.Wrapper>
      <Styled.ErrorWrapper>
        {chatError && chatLoadingStatus === 'idle' && (
          <ChatRequestError onResend={resend} error={chatError} />
        )}
      </Styled.ErrorWrapper>
      {chatState !== ChatStates.LOADING && showFreeTextEditor && (
        <FreeTextInputEditor nodeAction={prevRenderedNode?.action} />
      )}
      {chatState !== ChatStates.LOADING && !showFreeTextEditor && (
        <BranchingOptions />
      )}
    </Styled.Wrapper>
  );
};

export default BranchingInputArea;
